/**
 * @ngInject
 * Compiles input with html tags in and makes Angular directives as "ng-click" available in scope.
 */

function compileHtmlWithDirectives($compile) {
    return function(scope, element, attrs) {
        scope.$watch(
            function(scope) {
                return scope.$eval(attrs.compile);
            },
            function(value) {
                element.html(value.toString());
                $compile(element.contents())(scope);
            }
        )};
}